// extracted by mini-css-extract-plugin
export var acitonButtons = "_fq-0";
export var additionalIcon = "_fq-f";
export var block = "_fq-1";
export var blockContent = "_fq-7";
export var blockDescription = "_fq-8";
export var blockIcon = "_fq-9";
export var blockTitle = "_fq-6";
export var border = "_fq-a";
export var center = "_fq-l";
export var edge = "_fq-b";
export var edgeLabel = "_fq-c";
export var edgePath = "_fq-d";
export var error = "_fq-e";
export var flowchart = "_fq-g";
export var flowchartContent = "_fq-h";
export var highlighted = "_fq-3";
export var hover = "_fq-4";
export var icon = "_fq-i";
export var left = "_fq-m";
export var navButton = "_fq-j";
export var navButtons = "_fq-k";
export var right = "_fq-n";
export var selected = "_fq-2";
export var small = "_fq-5";